export { default as basicPipelineDashboardActions } from './basic'